export const services = [
  {
    id: 1,
    icon: "⌘",
    title: "Enterprise Systems",
    description: "Custom-built automation, management, and intelligence tools engineered to streamline operations and strengthen decision-making.",
    features: ["Process automation", "Custom CRM & ERP", "Data architecture & analytics"],
    link: "/services/enterprise",
    linkText: "Request Consultation",
    category: "development"
  },
  {
    id: 2,
    icon: "⟢",
    title: "Web Platforms",
    description: "Scalable, secure web platforms built with React, Next.js, and Node—optimized for performance, maintainability, and growth.",
    features: ["E-commerce systems", "Web portals & SaaS", "API development & integrations"],
    link: "/services/web-platforms",
    linkText: "View Case Studies",
    category: "development"
  },
  {
    id: 3,
    icon: "↯",
    title: "Mobile Solutions",
    description: "Cross-platform apps designed for performance, native feel, and seamless synchronization across devices and services.",
    features: ["React Native apps", "Enterprise mobility", "IoT-enabled systems"],
    link: "/services/mobile-solutions",
    linkText: "Discuss Project",
    category: "development"
  },
  {
    id: 4,
    icon: "⍟",
    title: "Digital Branding",
    description: "Unified brand systems blending strategy, design, and usability to create lasting digital identities.",
    features: ["Visual identity & logo", "UX/UI design systems", "Brand documentation"],
    link: "/services/branding",
    linkText: "See Portfolio",
    category: "design"
  },
  {
    id: 5,
    icon: "🚀",
    title: "Web Development",
    description: "We build fast, scalable websites and web apps with precision. Every line of code focuses on performance, security, and clean design.",
    features: ["Responsive design", "Performance optimization", "Security implementation"],
    link: "/services/web-development",
    linkText: "View Work",
    category: "development"
  },
  {
    id: 6,
    icon: "📈",
    title: "SEO & Marketing",
    description: "We engineer visibility through technical SEO, content strategy, and analytics. The goal: reach your audience, rank higher, and convert effectively.",
    features: ["Technical SEO audit", "Content strategy", "Analytics & reporting"],
    link: "/services/seo",
    linkText: "Boost Growth",
    category: "marketing"
  }
];